export const ISLive = process.env.REACT_APP_IS_LIVE === '1'

export const BaseUrls: any = {
	S3_BASE_URL: {
		url: ISLive ? process.env.REACT_APP_S3_BUCKET_URL_LIVE : process.env.REACT_APP_S3_BUCKET_URL_UAT
	},
	RUGNA_MITRA_ADMIN_SERVER: {
		url: ISLive ? process.env.REACT_APP_API_BASE_URL_LIVE : process.env.REACT_APP_API_BASE_URL_UAT
	}
}

export const ENC_KEY_STRING = process.env.REACT_APP_ENCRYPTION_KEY || '';
export const IV_STRING = process.env.REACT_APP_ENCRYPTION_IV;